import { StoreAction, XmAction } from 'store/actions';
import { OneTimePayment, OneTimePaymentResult } from './models';

export function oneTimePaymentReducer(state: OneTimePayment, action: XmAction<OneTimePayment>): OneTimePayment {
    switch (action.type) {
        case StoreAction.SAVE_ONE_TIME_PAYMENT_DATA:
        case StoreAction.GET_ONE_TIME_PAYMENT:
        case StoreAction.CLEAR_ONE_TIME_PAYMENT:
            return action.payload;
        default:
            return state;
    }
}

export function oneTimePaymentResultReducer(state: OneTimePaymentResult, action: XmAction<OneTimePaymentResult>): OneTimePaymentResult {
    switch (action.type) {
        case StoreAction.POST_ONE_TIME_PAYMENT:
            return action.payload;
        default:
            return state;
    }
}
